import React from 'react';

function Statistics251Changelog() {
  return (
    <div>
      <h6>DATA:</h6>
      <ul>
        <li className="bullet-item">
          Fixed a bug in the data pipeline to generate the Chemical Effect data available in the Evidence
          table
        </li>
        <li className="bullet-item">
          Improved the chemical & drug Named Entity Recognition to remove false positives such as p25, Ras,
          and p53.
        </li>
        <li className="bullet-item">
          Removed the string “null” from some gene entries, which resulted in false positives in the
          identification of genes. The affected genes are PHB2 (11331), ACOT7 (11332), C17orf114 (119139905),
          ACOT12 (134526), CYB5R3 (1727), ACSBG1 (23205), RHOQ (23433), MS4A4A (51338), LRP1B (53353), LGALS14
          (56891).
        </li>
      </ul>
    </div>
  );
}

export default Statistics251Changelog;
